// extracted by mini-css-extract-plugin
module.exports = {"logo":"ResponsiveWingspanLogo_logo__28oOU","partner":"ResponsiveWingspanLogo_partner__3Rg-6","inline":"ResponsiveWingspanLogo_inline__dwn1h"};